export default __webpack_public_path__ + "static/media/founderpen.aa15276e.png";